import { toast, type ToastOptions } from "react-toastify";
import { Bounce } from "react-toastify";

const defaultConfig: ToastOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  theme: "colored",
  transition: Bounce,
};

export const showError = (message: string) => toast.error(message, defaultConfig);
export const showSuccess = (message: string) => toast.success(message, defaultConfig);
export const showInfo = (message: string) => toast.info(message, defaultConfig);
export const showWarning = (message: string) => toast.warn(message, defaultConfig);
